import { Controller } from 'stimulus';

export default class AnchorNavigationController extends Controller {
  static targets = ['section', 'link'];

  active = null;

  index = 0;

  offsets = {};

  initialized = false;

  connect() {
    this.index = this.linkTargets
      .findIndex((element) => element.classList.contains('active'));
    this.index = this.index < 0 ? 0 : this.index;
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll, { passive: true });
    window.removeEventListener('resize', this.onResize);
  }

  recalculate() {
    const maxOffset = document.documentElement.scrollHeight - window.innerHeight;

    for (let i = 0; i < this.sectionTargets.length; i++) {
      this.offsets[this.sectionTargets[i].id] = Math.min(
        maxOffset,
        this.sectionTargets[i].getBoundingClientRect().top + window.pageYOffset,
      );
    }
  }

  onResize = () => window.requestAnimationFrame(() => this.recalculate());

  onScroll = () => {
    if (!this.sectionTargets.length) {
      return;
    }

    if (!this.initialized) {
      this.initialized = true;
      this.recalculate();
    }

    let index = -1;
    let active = this.sectionTargets[0].id;

    for (let i = 0; i < this.sectionTargets.length; i++) {
      const { id } = this.sectionTargets[i];
      if (window.pageYOffset >= this.offsets[id]) {
        active = id;
        index = i;
      }
    }

    if (index === -1) {
      active = null;
    }

    if (active !== this.active) {
      const hash = index < 0 ? '' : `#${active}`;
      this.linkTargets[this.index].classList.remove('active');
      this.active = active;
      this.index = index < 0 ? 0 : index;
      this.linkTargets[this.index].classList.add('active');
      window.history.replaceState({}, document.title, window.location.pathname + hash);
    }
  };
}
